import axios from '@fuse/utils/axios'

const getAllCompany = (params) => axios.get(`/company/fetch/paginated-company?page=${params?.page}${params?.search ? `&search=${params.search}`: ''}`);

export {
    getAllCompany,
}
